/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:23919efd-f9f3-4c51-a985-47f9bd3480e9",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_w6VlOYhGT",
    "aws_user_pools_web_client_id": "10psmfllt9hm8vugbtpkc0ois0",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://hezaahpor5hjbibcptxcudejne.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "tvtlogisticsindia51e5f43f2e8245a1ad77b87cf20bb095531-prod",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
